<div class="card" style="height: 90vh;">
  <div class="card-body">

    <div class="form-container">

      <!-- Patient -->
      <select-drop-down
        [items]="doctorPatients"
        [(ngModel)]="userTarget"
        [placeHolder]="'Chercher ici Patient'"
        [options]="{ filter:{ byKey:'fullName',with:'containe' } }"
        class="full-width"
      >
        <ng-template let-item="item">
          <div class="user-item">
            <img [src]="item | avatarSrc" />
            <span>{{ item.getFullName() }}</span>
          </div>
        </ng-template>
      </select-drop-down>

<!-- Date -->
<div class="divRow">
  <label class="label">Date Rdv</label>
  <input type="text"
         class="form-control"
         placeholder="JJ/MM/AAAA"
         name="dateRdv"
         [(ngModel)]="date" />
</div>
      <!-- Heure SELECT -->
      <div class="divRow" *ngIf="secrectary.doctor.duplicateAppointment == false">
        <label class="label">Heure Rdv</label>

        <select [(ngModel)]="disponibilite"
                (change)="change($event)"
                class="form-control">

          <option [ngValue]="disponibilite"
                  *ngIf="disponibiliteDefalut == 0 && !changeValueDisponibilte"
                  disabled selected>
            {{ disponibilite.startTime | time }}
          </option>

          <option [ngValue]="disponibilite"
                  *ngIf="disponibiliteDefalut !== 0 && !changeValueDisponibilte"
                  disabled selected>
            {{ disponibiliteDefalut | time }}
          </option>

          <option *ngFor="let dispo of disponibilites | disponibiliteFilter:location"
                  [ngValue]="dispo">
            {{ dispo.startTime | time }}
          </option>

          <option *ngIf="(disponibilites | disponibiliteFilter:location)?.length === 0"
                  [ngValue]="null" disabled>
            Aucune disponibilité
          </option>

        </select>
      </div>

      <!-- Heure INPUT -->
      <div class="divRow" *ngIf="secrectary.doctor.duplicateAppointment == true">
        <label class="label">Heure Rdv</label>
        <input type="time"
               class="form-control"
               [(ngModel)]="heureInput"
               (change)="onTimeChange($event)" />
      </div>

      <!-- LOCATION -->
      <div class="divRow">
        <label class="label">Location </label>

        <div class="radio-container">
          <label *ngIf="secrectary.doctor.timeSlotLocalSetting | locationEnabled: 'cabinet'">
            <input type="radio" name="location" [(ngModel)]="location" [value]="0"/>
            <span>En Cabinet</span>
          </label>

          <label *ngIf="secrectary.doctor.timeSlotLocalSetting | locationEnabled: 'online'">
            <input type="radio" name="location" [(ngModel)]="location" [value]="1"/>
            <span>A Distance</span>
          </label>
        </div>
      </div>

      <!-- INTERVENANT + COLOR -->
      <div class="form-row-double" *ngIf="secrectary.doctor.duplicateAppointment == true">

        <!-- Intervenant -->
        <div class="intervenant">
          <label class="label">Intervenant</label>

          <select [(ngModel)]="selectedUser"
                  [compareWith]="compareUsers"
                  (change)="onUserChange()"
                  class="form-control">

            <option *ngFor="let user of usersList; trackBy: trackById"
                    [ngValue]="user">
              {{ user.type === 'DOCTOR' ? "Dr."+user.fullName : user.fullName }} ({{ user.type === 'DOCTOR' ? 'Médecin' : 'Assistant' }})

            </option>

          </select>
        </div>

        <!-- Couleur -->
        <div class="color">
          <div class="color-picker-wrapper" (click)="toggleDropdown()">

            <div class="selected-color">
              <span class="circle" [style.background]="selectedColor"></span>
            </div>

            <span class="color-arrow">▼</span>

            <ul class="color-dropdown" *ngIf="isOpen">
              <li *ngFor="let c of colors"
                  (click)="selectColor(c.value); $event.stopPropagation()">
                <span class="circle" [style.background]="c.value"></span>
              </li>
            </ul>

          </div>
        </div>

      </div>

      <!-- COULEUR (cas duplicate = false) -->
      <div class="divRow" *ngIf="secrectary.doctor.duplicateAppointment == false">
        <label class="label">Couleur</label>

        <div class="color-picker-wrapper" (click)="toggleDropdown()">
          <div class="selected-color">
            <span class="circle" [style.background]="doctorAppointment.colorCode"></span>
          </div>

          <span class="color-arrow">▼</span>

          <ul class="color-dropdown" *ngIf="isOpen">
            <li *ngFor="let c of colors"
                (click)="selectColor(c.value)">
              <span class="circle" [style.background]="c.value"></span>
            </li>
          </ul>
        </div>
      </div>

      <!-- MOTIF -->
      <div class="divRow">
        <label class="label">Motif</label>

        <select [(ngModel)]="doctorAppointment.motif" class="form-control">
          <option value="Consultation Régulière">Consultation Régulière</option>
          <option value="Consultation Controle">Consultation Controle</option>

          <option *ngFor="let motif of consultationMotifs"
                  [value]="motif.text"
                  [ngStyle]="{'color': motif.color || '#820040'}">
            {{ motif.text }}
          </option>
        </select>
      </div>

    </div>

  </div>

  <!-- SUBMIT -->
  <div class="submit-section">
    <button class="btn btn-primary submit-btn" (click)="sumbit()">
      Modifier
    </button>
  </div>

</div>